import Button from "@storeblocks/button";
import Cookies from "js-cookie";
import React from "react";

import artifactInfo from "../../../artifactInfo.json";
import { TestBranchBanner } from "./styled";

export const FEATURE_BRANCH_COOKIE_NAME = "features";

export const TestBanner = ({
  appName,
  featuresCookie,
}: {
  appName: string;
  featuresCookie: string | undefined;
}): React.ReactElement => {
  const removeFeatureCookie = (): void => {
    Cookies.remove(FEATURE_BRANCH_COOKIE_NAME);
    window.location.reload();
  };

  return (
    <TestBranchBanner>
      {featuresCookie ? (
        <>
          You are testing feature branch:{" "}
          {getFeatureBranchText(appName, featuresCookie)} - close to return to
          test
          <Button
            variant="text"
            iconRight="close"
            onClick={removeFeatureCookie}
            color="on-surface"
          />
        </>
      ) : (
        <>TEST: {artifactInfo.gitShaShort}</>
      )}
    </TestBranchBanner>
  );
};

export const getFeatureBranchText = (
  appName: string,
  featuresCookie: string,
): string => {
  const regex = new RegExp(`^${appName}:(.+)$`);
  const values = regex.exec(featuresCookie);
  if (values && values.length > 1) {
    return values[1];
  }
  return featuresCookie;
};
